import React, { useState, useEffect } from 'react';
import { API_BASE_URL } from './config';

// THis is to serve as the edit event modal.
function EventDetailsModal({ isOpen, onClose, event, posterUrl, djs = [], onUpdate }) {
    const [isEditing, setIsEditing] = useState(false);
    const [djId, setDjId] = useState(null);
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');

    useEffect(() => {
        if (event) {
            const iso = event.start.toISOString();
            const isoEnd = event.end.toISOString();
            setStartTime(iso.substring(11, 16));
            setEndTime(isoEnd.substring(11, 16));
            setDjId(event.dj_id || null); // fallback if not included
        }
    }, [event]);

    const handleSave = async () => {
        const dateStr = event.start.toISOString().split('T')[0];

        const response = await fetch(`${API_BASE_URL}/api/schedule/edit/${event.id}/`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('access')}`
            },
            body: JSON.stringify({
                date: dateStr,
                dj_id: djId,
                start_time: startTime,
                end_time: endTime
            })
        });

        if (response.ok) {
            const result = await response.json();
            setIsEditing(false);
            onUpdate(result); // trigger event update in parent
        } else {
            alert("Failed to update event");
        }
    };

    if (!isOpen || !event) return null;

    const date = event.start.toLocaleDateString();

    return (
        <div style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 1000,
            display: 'flex', justifyContent: 'center', alignItems: 'center'
        }}>
            <div style={{
                backgroundColor: '#fff', padding: '2rem', borderRadius: '12px',
                maxWidth: '500px', width: '100%', textAlign: 'center'
            }}>
                <h2>{event.title}</h2>
                <p><strong>Date:</strong> {date}</p>
                {event.resource?.locationName && (
                    <p><strong>Location:</strong> {event.resource.locationName}</p>
                )}

                {isEditing ? (
                    <>
                        <label>DJ:</label><br />
                        <select value={djId || ''} onChange={e => setDjId(e.target.value)} style={{ marginBottom: '1rem' }}>
                            <option value="">-- Select DJ --</option>
                            {djs.map(dj => (
                                <option key={dj.id} value={dj.id}>{dj.name}</option>
                            ))}
                        </select><br />

                        <label>Start Time:</label><br />
                        <input type="time" value={startTime} onChange={e => setStartTime(e.target.value)} /><br />

                        <label>End Time:</label><br />
                        <input type="time" value={endTime} onChange={e => setEndTime(e.target.value)} /><br />
                    </>
                ) : (
                    <p><strong>Time:</strong> {startTime} – {endTime}</p>
                )}

                {posterUrl && (
                    <img src={posterUrl} alt="Poster" style={{ maxHeight: '5%', width: '50%', borderRadius: '8px', marginTop: '1rem' }} />
                )}

                <p>Share to Instagram</p>

                {isEditing ? (
                    <div style={{ marginTop: '1rem' }}>
                        <button onClick={handleSave} style={{ marginRight: '1rem' }}>Save</button>
                        <button onClick={() => setIsEditing(false)}>Cancel</button>
                    </div>
                ) : (
                    <button onClick={() => setIsEditing(true)} style={{ marginTop: '1rem' }}>Edit</button>
                )}

                <button
                    onClick={onClose}
                    style={{
                        marginTop: '1rem',
                        padding: '0.5rem 1rem',
                        borderRadius: '6px',
                        display: 'block',
                        marginLeft: 'auto',
                        marginRight: 'auto'
                    }}>
                    Close
                </button>
            </div>
        </div>
    );
}

export default EventDetailsModal;